<template>
  <v-container fluid class="text-center bg-white py-12">
    <h1 class="text-pink">Plan updated!</h1>
    <v-img
      :src="require('@/assets/img/resolutions/finish_2.png')"
      aspect-ratio="1"
      contain
      class="mb-8"
      width="auto"
      height="400px"
      style="margin: 0 auto"
    ></v-img>
    <p class="title">
      Thanks for your purchase {{ userDetails.name }}. We hope you enjoy using
      theLIFEBOARD 😊
    </p>
    <v-btn color="primary" @click="redirect">{{
      isLoggedIn ? 'Continue to my dashboard' : 'Log in'
    }}</v-btn>
  </v-container>
</template>

<script>
import {mapGetters} from 'vuex'

export default {
  props: ['subscription'],
  computed: {
    ...mapGetters(['isLoggedIn', 'userDetails']),
  },
  async mounted() {
    console.log(this.subscription)
    await this.$store.dispatch('getSubscription', {
      email: this.userDetails.email,
    })
    await this.$store.dispatch('createUserEvent', {
      eventName: 'trialUpgraded',
    })
  },
  methods: {
    redirect() {
      if (this.userDetails.name) {
        this.$router.push({
          name: 'goalshabits',
          params: {name: this.userDetails.name},
        })
      } else {
        this.$router.push({name: 'login'})
      }
    },
  },
}
</script>

<style></style>
